import { booleanAttribute, Component, EventEmitter, input, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-commitment-entry-text',
  templateUrl: './commitment-entry-text.component.html',
  styleUrls: ['./commitment-entry-text.component.scss'],
  imports: [CommonModule],
})
export class CommitmentEntryTextComponent {
  @Input() text: string;
  @Input() entryType: 'General' | 'GeneralInfo' = 'General';
  @Input() index = null;
  @Input() disableRemoveEntry = false;

  showRemoveIcon = input<boolean, string | boolean>(false, { transform: booleanAttribute });

  @Output() removeClicked = new EventEmitter<void>();

  removeEntry() {
    this.removeClicked.emit();
  }
}
